module.exports = __webpack_public_path__ + "assets/img/light-pollution.14c6389a.jpg";